import { json } from "react-router-dom";
import { get } from "../../../apiClient";

export async function soxEmailDownload(params) {
  try {
    const { id } = params;
    return await get("managed_plus", `/sox_email/${id}`);
  } catch (error) {
    switch (error.status) {
      case 400:
      case 422: {
        return json(error.details, { status: error.status });
      }
      default:
        throw error;
    }
  }
}

export const NoEmailsFoundWarning = () => {
  return (
    <div
      style={{
        textAlign: "center",
        marginTop: "150px",
      }}
    >
      <span
        style={{
          display: "inline-block",
          color: "rgba(37, 92, 142, 1)",
          fontSize: "20px",
          fontFamily: "Roboto, sans-serif",
          fontWeight: 400,
        }}
      >
        No Data Available
      </span>
    </div>
  );
};
